module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-06.2803019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-06.jpg
// module id = QkEo
// module chunks = 52